export const BUY_BUTTON_TYPES = {
  PRODUCT_CARD: 1,
  PRODUCT_CARD_VAULT_LOCATION: 2,
  LOCATION_PRICE_TIERS: 3,
  POSITION_DETAIL_PAGE: 4,
};

export default {
  [BUY_BUTTON_TYPES.PRODUCT_CARD]: 'ProductCard',
  [BUY_BUTTON_TYPES.PRODUCT_CARD_VAULT_LOCATION]: 'ProductCardVaultLocation',
  [BUY_BUTTON_TYPES.LOCATION_PRICE_TIERS]: 'LocationPriceTiers',
  [BUY_BUTTON_TYPES.POSITION_DETAIL_PAGE]: 'PositionDetailPage',
};

export const BUY_FLOW_STEPS_ENUM = {
  SELECT_DESTINATION: 1,
  SELECT_DELIVERY_ADDRESS: 2,
  SELECT_AMOUNT: 3,
  SELECT_PAYMENT_METHOD: 4,
  REVIEW_ORDER: 5,
};

export const SELL_BUTTON_TYPE = {
  PRODUCT_CARD: 'ProductCard',
  POSITION_DETAIL_PAGE: 'PositionDetailPage',
};

export const BUY_FLOW_STEPS = {
  [BUY_FLOW_STEPS_ENUM.SELECT_DESTINATION]: 'SelectDestination',
  [BUY_FLOW_STEPS_ENUM.SELECT_DELIVERY_ADDRESS]: 'SelectDeliveryAddress',
  [BUY_FLOW_STEPS_ENUM.SELECT_AMOUNT]: 'SelectAmount',
  [BUY_FLOW_STEPS_ENUM.SELECT_PAYMENT_METHOD]: 'SelectPaymentMethod',
  [BUY_FLOW_STEPS_ENUM.REVIEW_ORDER]: 'ReviewOrder',
};

export const BUY_FLOW_ORDER_TYPE = {
  buyForDelivery: 'BuyForDelivery',
  buyForStorage: 'BuyForStorage',
};

export const EVENT_TYPES_ENUM = {
  Fund_Blocked: 1,
  Fund_OrderStarted: 2,
  Fund_SelectedAmount: 3,
  Fund_SelectedMethodType: 4,
  Sell_OrderStarted: 5,
  Sell_SelectedAmount: 6,
  Bank_AddStarted: 7,
  TwoFA_VerificationStarted: 8,
};

export const FUND_ORDER_STARTED_TYPE = {
  MainNavigation: 'MainNavigation',
  PortfolioPage: 'PortfolioPage',
  BalancesPage: 'BalancesPage',
};

export const FUND_SELECTED_METHOD_TYPE = {
  ACH: 'ACH',
  CHECK: 'Check',
  WIRE: 'Wire',
};

export const BANK_ADD_STARTED_TYPE = {
  MyBanksPage: 'MyBanksPage',
  BuyWizard: 'BuyWizard',
  FundWizard: 'FundWizard',
};

export const BANK_PERMISSION = {
  Deposit: 'Deposit',
  Withdrawal: 'Withdrawal',
};
